

<div class="sidenav-toggle" *ngIf="expandedElement == null">
  <button mat-button (click)="sidenav.toggle()"><mat-icon *ngIf="!sidenav?.opened">menu</mat-icon><mat-icon *ngIf="sidenav?.opened">menu_open</mat-icon></button>
</div>



<mat-sidenav-container class="example-container">

  <mat-sidenav #sidenav mode="side" [(opened)]="menuOpened" position="end" [style.display]="expandedElement == null ? 'block': 'none'">
    <h3 class="side-menu-header">Menu</h3>

    
    <form class="example-form">
      <div>
        <p-calendar name="globalFilters.dateRange" [ngModel]="[startDate | async,endDate | async]" (ngModelChange)="startDate.next($event[0]);endDate.next($event[1])" selectionMode="range" [readonlyInput]="true" inputId="range" dateFormat="dd/mm/yy" [showIcon]="true" showButtonBar="true" [minDate]="minStartDate | async"></p-calendar>
      </div>

      <div>
        <companies-autocomplete (onSelectCompany)="company.next($event)"></companies-autocomplete>
      </div>

      <mat-form-field appearance="fill" style="display:none;">
        <mat-label>Scale</mat-label>
        <mat-select [(value)]="scale">
          <mat-option value="1">Large</mat-option>
          <mat-option value="1.5">Medium</mat-option>
          <mat-option value="2">Small</mat-option>
        </mat-select>


      </mat-form-field>
    </form>
  </mat-sidenav>

  <mat-sidenav-content>
    <div style="padding: 1%">
      <mat-grid-list cols="2" [rowHeight]="(document.documentElement.clientHeight / scale) - 40" [gutterSize]="'20px'">
        <mat-grid-tile *ngIf="showTotalPlacedCalls"
                       style="overflow-x: auto;">
          <div #expandable class="expandable" [class.fullscreen]="expandedElement==expandable">

            <div class="tab-container">
              <mat-tab-group #tabRef>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span class="custom-class">Hour</span>
                  </ng-template>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span class="custom-class">Day</span>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </div>

            <div class="tile-container">
              <ng-template #totalPlacedCallsTooltipTemplate let-model="model">
                <div style="padding:5px;">Direction <span class="fa fa-circle"></span> {{model.series}}</div>
                <div style="padding:5px;">Time Period <span class="fa fa-circle"></span> {{model.data.startTime | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
                <div style="padding:5px;">Count <span class="fa fa-circle"></span> {{model.data.count}}</div>
              </ng-template>

              <ng-template #totalPlacedCallsSeriesTooltipTemplate let-model="model">
                <div class="area-tooltip-container">
                  {{model[0].name | date: 'dd/MM/yyyy HH:mm:ss'}}
                  <div *ngFor="let plot of model" class="tooltip-item">
                    <span class="tooltip-item-color" [style.background-color]="plot.color"></span>
                    {{plot.series}}: {{plot?.value}}
                  </div>
                </div>
              </ng-template>

              <graphql-line-chart *ngIf="tabRef.selectedIndex == null || tabRef.selectedIndex == 0"
                                  [query]="totalPlacedCalls_HourQuery | async"
                                  [options]="object.assign({}, totalPlacedCallsOptions,{xAxisLabel: 'Hour' })"
                                  (select)="selectGraph($event)">
                <ng-template #eveTooltipTemplate let-model="model">
                  <ng-container *ngTemplateOutlet="totalPlacedCallsTooltipTemplate;context:{model}"></ng-container>
                </ng-template>
                <ng-template #eveSeriesTooltipTemplate let-model="model">
                  <ng-container *ngTemplateOutlet="totalPlacedCallsSeriesTooltipTemplate;context:{model}"></ng-container>
                </ng-template>
              </graphql-line-chart>
              <graphql-line-chart *ngIf="tabRef.selectedIndex == 1"
                                  [query]="totalPlacedCalls_DayQuery| async"
                                  [options]="object.assign({}, totalPlacedCallsOptions,{xAxisLabel: 'Day' })"
                                  (select)="selectGraph($event)">
                <ng-template #eveTooltipTemplate let-model="model">
                  <ng-container *ngTemplateOutlet="totalPlacedCallsTooltipTemplate;context:{model}"></ng-container>
                </ng-template>
                <ng-template #eveSeriesTooltipTemplate let-model="model">
                  <ng-container *ngTemplateOutlet="totalPlacedCallsSeriesTooltipTemplate;context:{model}"></ng-container>
                </ng-template>
              </graphql-line-chart>
            </div>
            <mat-grid-tile-header>
              {{ totalPlacedCallsOptions.chartHeader }}
              <span class="example-spacer"></span>
              <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="expandedElement=(expandedElement == null ? expandable: null)" title="{{TotalPlacedCallsExpanded == true ? 'minimise' : 'expand'}}">
                <mat-icon>{{expandedElement == expandable ? "minimize" : "expand"}}</mat-icon>
              </button>
            </mat-grid-tile-header>
          </div>
        </mat-grid-tile>

        <mat-grid-tile *ngIf="showTotalDuration">
          <div #expandable class="expandable" [class.fullscreen]="expandedElement==expandable">
            <div class="tab-container">
              <mat-tab-group #totalDurationTabRef>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span class="custom-class">Hour</span>
                  </ng-template>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span class="custom-class">Day</span>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </div>

            <div class="tile-container">
              <ng-template #totalDurationTooltipTemplate let-model="model">
                <div style="padding:5px;">Direction <span class="fa fa-circle"></span> {{model.series}}</div>
                <div style="padding:5px;">Time Period <span class="fa fa-circle"></span> {{model.data.startTime | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
                <div style="padding:5px;">Duration <span class="fa fa-circle"></span> {{model.data.duration | secondsToTimeSpan}}</div>
              </ng-template>

              <ng-template #totalDurationSeriesTooltipTemplate let-model="model">
                <div class="area-tooltip-container">
                  {{model[0].name | date: 'dd/MM/yyyy HH:mm:ss'}}
                  <div *ngFor="let plot of model" class="tooltip-item">
                    <span class="tooltip-item-color" [style.background-color]="plot.color"></span>
                    {{plot.series}}: {{(plot?.data?.duration ?? 0) | secondsToTimeSpan}}
                  </div>
                </div>
              </ng-template>

              <graphql-line-chart *ngIf="totalDurationTabRef.selectedIndex == null || totalDurationTabRef.selectedIndex == 0"
                                  [query]="totalDuration_HourQuery | async"
                                  [graphQlResultsSeriesOptions]="totalDurationResultsSeriesOptions"
                                  [options]="object.assign({}, totalDurationOptions,{xAxisLabel: 'Hour' })"
                                  (select)="selectGraph($event)">
                <ng-template #eveTooltipTemplate let-model="model">
                  <ng-container *ngTemplateOutlet="totalDurationTooltipTemplate;context:{model}"></ng-container>
                </ng-template>
                <ng-template #eveSeriesTooltipTemplate let-model="model">
                  <ng-container *ngTemplateOutlet="totalDurationSeriesTooltipTemplate;context:{model}"></ng-container>
                </ng-template>

              </graphql-line-chart>

              <graphql-line-chart *ngIf="totalDurationTabRef.selectedIndex == 1"
                                  [query]="totalDuration_DayQuery | async"
                                  [graphQlResultsSeriesOptions]="totalDurationResultsSeriesOptions"
                                  [options]="object.assign({}, totalDurationOptions,{xAxisLabel: 'Day' })"
                                  (select)="selectGraph($event)">
                <ng-template #eveTooltipTemplate let-model="model">
                  <ng-container *ngTemplateOutlet="totalDurationTooltipTemplate;context:{model}"></ng-container>
                </ng-template>
                <ng-template #eveSeriesTooltipTemplate let-model="model">
                  <ng-container *ngTemplateOutlet="totalDurationSeriesTooltipTemplate;context:{model}"></ng-container>
                </ng-template>
              </graphql-line-chart>

            </div>
            <mat-grid-tile-header>
              {{ totalDurationOptions.chartHeader }}
              <span class="example-spacer"></span>
              <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="expandedElement=(expandedElement == null ? expandable: null)" title="{{totalDurationExpanded == true ? 'minimise' : 'expand'}}">
                <mat-icon>{{expandedElement == expandable ? "minimize" : "expand"}}</mat-icon>
              </button>
            </mat-grid-tile-header>
          </div>
        </mat-grid-tile>

        <mat-grid-tile *ngIf="showCallsByUser">
          <ng-container *ngTemplateOutlet="CallsByUserTemplate"></ng-container>
        </mat-grid-tile>





        <mat-grid-tile *ngIf="showCallsByDestination" >
          <div #expandable class="expandable" [class.fullscreen]="expandedElement==expandable">
            <div class="tab-container">
              <mat-tab-group #callsByDestinationTabRef>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span class="custom-class">Minutes</span>
                  </ng-template>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span class="custom-class">Quantity</span>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </div>

            <div class="tile-container">
              

              <graphql-pie-chart *ngIf="callsByDestinationTabRef.selectedIndex == null || callsByDestinationTabRef.selectedIndex == 0"
                                 [query]="callsByDestination_MinutesQuery | async"
                                 [graphQlResultsSeriesOptions]="callsByDestination_MinutesResultsSeriesOptions"
                                 [options]="object.assign({}, pieChartOptions2,{yAxisLabel: 'Minutes' })"
                                 (select)="selectGraph($event)">
                <ng-template #eveTooltipTemplate let-model="model">
                  <div style="padding:5px;">Destination <span class="fa fa-circle"></span> {{model.name}}</div>
                  <div style="padding:5px;">Duration <span class="fa fa-circle"></span> {{model.value * 60 | secondsToTimeSpan }}</div>
                </ng-template>
              </graphql-pie-chart>
              <graphql-pie-chart *ngIf="callsByDestinationTabRef.selectedIndex == 1"
                                 [query]="callsByDestination_QuantityQuery | async"
                                 [options]="object.assign({}, pieChartOptions2,{yAxisLabel: 'Quantity' })"
                                 (select)="selectGraph($event)">
                <ng-template #eveTooltipTemplate let-model="model">
                  <div style="padding:5px;">Destination <span class="fa fa-circle"></span> {{model.name}}</div>
                  <div style="padding:5px;">Quantity <span class="fa fa-circle"></span> {{model.value}}</div>
                </ng-template>
              </graphql-pie-chart>
            </div>
            <mat-grid-tile-header>
              {{ callsByDestinationOptions.chartHeader }}
              <span class="example-spacer"></span>
              <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="expandedElement=(expandedElement == null ? expandable: null)" title="{{callsByDestinationExpanded == true ? 'minimise' : 'expand'}}">
                <mat-icon>{{expandedElement == expandable ? "minimize" : "expand"}}</mat-icon>
              </button>
            </mat-grid-tile-header>
          </div>
        </mat-grid-tile>
      </mat-grid-list>

    </div>
  </mat-sidenav-content>
</mat-sidenav-container>




<ng-template #CallsByUserTemplate>
  <div #expandable class="expandable" [class.fullscreen]="expandedElement==expandable">
    <div class="tab-container">
      <mat-tab-group #callsByUserTabRef>
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="custom-class">Minutes</span>
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="custom-class">Quantity</span>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div class="tile-container">
      

      <graphql-stacked-bar-chart-pagination *ngIf="callsByUserTabRef.selectedIndex == null || callsByUserTabRef.selectedIndex == 0"
                                 [query]="callsByUser_MinutesQuery | async"
                                 [graphQlResultsSeriesOptions]="callsByUser_MinutesGraphQlResultsSeriesOptions"
                                 [options]="object.assign({}, callsByUserOptions,{yAxisLabel: 'Minutes' })"
                                 (select)="selectGraph($event)">
        <ng-template #eveTooltipTemplate let-model="model">
          <div style="padding:5px;">Direction <span class="fa fa-circle"></span> {{model.name}}</div>
          <div style="padding:5px;">EveUser <span class="fa fa-circle"></span> {{model.series}}</div>
          <div style="padding:5px;">Duration <span class="fa fa-circle"></span> {{model.data.duration | secondsToTimeSpan}}</div>
        </ng-template>

      </graphql-stacked-bar-chart-pagination>
      <graphql-stacked-bar-chart-pagination *ngIf="callsByUserTabRef.selectedIndex == 1"
                                 [query]="callsByUser_QuantityQuery | async"
                                 [graphQlResultsSeriesOptions]="callsByUser_QuantityGraphQlResultsSeriesOptions"
                                 [options]="object.assign({}, callsByUserOptions,{yAxisLabel: 'Quantity' })"
                                 (select)="selectGraph($event)">
        <ng-template #eveTooltipTemplate let-model="model">
          <div style="padding:5px;">Direction <span class="fa fa-circle"></span> {{model.name}}</div>
          <div style="padding:5px;">EveUser <span class="fa fa-circle"></span> {{model.series}}</div>
          <div style="padding:5px;">Quantity <span class="fa fa-circle"></span> {{model.value }}</div>
        </ng-template>

      </graphql-stacked-bar-chart-pagination>
    </div>
    <mat-grid-tile-header>
      {{ callsByUserOptions.chartHeader }}
      <span class="example-spacer"></span>
      <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="openCallsByUserSelectionDialog()" title="user selection">
        <mat-icon>person_search</mat-icon>
      </button>
      <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="expandedElement=(expandedElement == null ? expandable: null)" title="{{callsByUserExpanded == true ? 'minimise' : 'expand'}}">
        <mat-icon>{{expandedElement == expandable ? "minimize" : "expand"}}</mat-icon>
      </button>

    </mat-grid-tile-header>
  </div>
</ng-template>

<ng-template #EveCdrsDialogTemplate let-query="query">
  <evecdr-datatable [query]="query">
  </evecdr-datatable>
</ng-template>



